import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Table from '@material-ui/core/Table';
import UnregisterdShopTableHead from '../../components/molecules/UnregisteredShopTableHead';
import UnregisterdShopTableBody from '../../components/molecules/UnregisteredShopTableBody';
import UnregisterdShopDetail from './UnregisteredShopDetail';
// import TablePagination from '../../components/molecules/TablePagination';
import ExPagination from '../../components/molecules/ExPagination';
import { getPreShopDetail } from '../../actions/PreShops';

const styles = {
  scrollTable: {
    maxHeight: 375,
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      preShops: state.preShops.preShops,
      totalCount: state.preShops.totalCount,
      offset: state.preShops.offset
    }),
    dispatch => ({
      actions: bindActionCreators({ getPreShopDetail }, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('openMailSendModal', 'updateOpenMailSendModal', false),
  withState('openMailSent', 'updateOpenMailSent', false),
  withState('preShopId', 'setPreShopId', 0),
  withState('preShopName', 'setPreShopName', ''),
  withState('zipCode', 'setZipCode', ''),
  withState('prefectureCode', 'setPrefectureCode', 0),
  withState('prefectures', 'setPrefectures', ''),
  withState('city', 'setCity', ''),
  withState('address', 'setAddress', ''),
  withState('building', 'setBuilding', ''),
  withState('phone', 'setPhone', ''),
  withState('businessHours', 'setBusinessHours', ''),
  withState('holiday', 'setHoliday', ''),
  withState('access', 'setAccess', ''),
  withState('webPage', 'setWebPage', ''),
  withState('message', 'setMessage', ''),
  withState('tags', 'setTags', null),
  withState('tagStr', 'setTagStr', ''),
  withState('preGochis', 'setPreGochis', null),
  withState('images', 'setImages', null),
  withState('email', 'setEmail', ''),
  withState('unregistered', 'setUnregistered', false),
  withState('createdAt', 'setCreatedAt', ''),
  withState('updatedAt', 'setUpdatedAt', ''),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('page', 'setPage', 0),
  withHandlers({
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    preShops,
    updateOpenShopAdd,
    progress,
    page,
    selectedPage,
    totalCount,
    offset,
    handleChangePage,
    openDetailModal,
    updateOpenDetailModal,
    rowsPerPage,
    preShopId,
    setPreShopId,
    preShopName,
    setPreShopName,
    zipCode,
    setZipCode,
    prefectureCode,
    setPrefectureCode,
    prefectures,
    setPrefectures,
    city,
    setCity,
    address,
    setAddress,
    building,
    setBuilding,
    phone,
    setPhone,
    businessHours,
    setBusinessHours,
    holiday,
    setHoliday,
    access,
    setAccess,
    webPage,
    setWebPage,
    message,
    setMessage,
    tags,
    setTags,
    tagStr,
    setTagStr,
    preGochis,
    setPreGochis,
    images,
    setImages,
    email,
    setEmail,
    createdAt,
    setCreatedAt,
    updatedAt,
    setUpdatedAt,
    targetRowId,
    setTargetRowId,
    handleChangeRowsPerPage
  }) => {
    const detail = {
      preShopId,
      preShopName,
      zipCode,
      prefectureCode,
      prefectures,
      city,
      address,
      building,
      phone,
      businessHours,
      holiday,
      access,
      webPage,
      message,
      tags,
      tagStr,
      preGochis,
      images,
      email,
      createdAt,
      updatedAt
    };
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);

    const getPreShop = async params => {
      const detailParams = {
        unregistered: params.unregistered
      };
      await actions
        .getPreShopDetail(params.id, detailParams)
        .then(detailData => {
          setPreShopId(detailData.payload.preShopId);
          setPreShopName(detailData.payload.preShopName);
          setZipCode(detailData.payload.zipCode);
          setPrefectureCode(detailData.payload.prefectureCode);
          setPrefectures(detailData.payload.prefectures);
          setCity(detailData.payload.city);
          setAddress(detailData.payload.address);
          setBuilding(detailData.payload.building);
          setPhone(detailData.payload.phone);
          setBusinessHours(detailData.payload.businessHours);
          setHoliday(detailData.payload.holiday);
          setAccess(detailData.payload.access);
          setWebPage(detailData.payload.webPage);
          setMessage(detailData.payload.message);
          setTags(detailData.payload.tags);
          setTagStr(
            detailData.payload.tags
              .map(tag => {
                return `${tag.tagName}`;
              })
              .join(' ')
          );
          setPreGochis(detailData.payload.preGochis);
          setImages(detailData.payload.images);
          setEmail(detailData.payload.email);
          setCreatedAt(detailData.payload.createdAt);
          setUpdatedAt(detailData.payload.updatedAt);
        });
    };
    const detailOpenAction = params => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      getPreShop(params)
        .then(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          updateOpenDetailModal(true);
        })
        .catch(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };
    const registerOpenAction = params => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      getPreShop(params)
        .then(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          updateOpenShopAdd(true);
        })
        .catch(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };

    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <UnregisterdShopTableHead />
            <UnregisterdShopTableBody
              preShops={preShops}
              emptyRows={emptyRows}
              page={page}
              rowsPerPage={rowsPerPage}
              updateOpenDetailModal={updateOpenDetailModal}
              updateOpenShopAdd={updateOpenShopAdd}
              setTargetRowId={setTargetRowId}
              detailOpenAction={detailOpenAction}
              registerOpenAction={registerOpenAction}
            />
          </Table>
        </div>
        <div>
          <ExPagination
            searchResults={preShops}
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            totalCount={totalCount}
            offset={offset}
            selectedPage={selectedPage}
          />
        </div>
        <Modal
          open={openDetailModal}
          onClose={() => {
            updateOpenDetailModal(false);
          }}
        >
          <UnregisterdShopDetail
            updateOpenDetailModal={updateOpenDetailModal}
            targetRowId={targetRowId}
            detail={detail}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
